import { on } from 'delegated-events';
import { getAccordionInstance } from '../../2-molecules/accordion/accordion';

on('accordion:open', '.accordions', (event: CustomEvent) => {
  const { target: $accordion } = event;

  if ($accordion instanceof HTMLDetailsElement) {
    const $accordions = $accordion.closest('.accordions__accordions');
    const $$accordion = $accordions?.querySelectorAll<HTMLDetailsElement>('.accordion');

    $$accordion?.forEach(($a) => {
      if ($a !== $accordion) {
        getAccordionInstance($a).shrink();
      }
    });
  }
});
